import { loggerNamespace } from '../lib/Logger'
import { rpc } from '../lib/Rpc'

class TaxonomyService {
  private logger = loggerNamespace('TaxonomyService')

  public getSimpleTaxonomyTree = async (businessId: string): Promise<ITaxonomyTreeItemSimple[]> => {
    const { error, result } = await rpc.call<ITaxonomyTreeItemSimple[]>('taxonomy.get_taxonomy_tree', {
      business: { id: businessId },
      fields: ['id', 'taxonomyParentID', 'alias'],
    })
    return Array.isArray(result) ? result.map(mapTaxTreeItem) : []
  }
}

function mapTaxTreeItem (item: TObjectAny): ITaxonomyTreeItemSimple {
  return {
    ...item,
    name: item.alias['ru-ru'] || item.alias['en-us'],
    children: item.children?.map(mapTaxTreeItem)
  } as ITaxonomyTreeItemSimple
}

export interface ITaxonomyTreeItemSimple {
  id: string
  name: string
  taxonomyParentID: string
  alias: TObjectAny
  order: number
  children?: ITaxonomyTreeItemSimple[]
}

const taxonomyService = new TaxonomyService()
export { taxonomyService }
